import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";

const DEFAULT_PASSWORD = "merch2024";
const DEFAULT_STORAGE_KEY = "site_authenticated";

interface PasswordGateProps {
  children: React.ReactNode;
  password?: string;
  storageKey?: string;
}

export const PasswordGate = ({ 
  children, 
  password: requiredPassword = DEFAULT_PASSWORD,
  storageKey = DEFAULT_STORAGE_KEY 
}: PasswordGateProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authenticated = sessionStorage.getItem(storageKey);
    if (authenticated === "true") {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, [storageKey]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === requiredPassword) {
      sessionStorage.setItem(storageKey, "true");
      setIsAuthenticated(true);
      setError("");
    } else {
      setError("Nesprávne heslo");
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Načítavam...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <div className="w-full max-w-sm">
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <div className="flex flex-col items-center space-y-3">
            <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center">
              <Lock className="w-7 h-7 text-primary" />
            </div>
            <h1 className="text-xl font-semibold text-foreground">Chránená stránka</h1>
            <p className="text-sm text-muted-foreground text-center">
              Pre prístup zadaj heslo
            </p>
          </div>
          
          <div className="space-y-4">
            <Input
              type="password"
              placeholder="Heslo"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              className="text-center"
              autoFocus
            />
            {error && (
              <p className="text-sm text-destructive text-center">{error}</p>
            )}
          </div>
          
          <Button type="submit" className="w-full">
            Vstúpiť
          </Button>
        </form>
      </div>
    </div>
  );
};
